import { FetchAPI, ModalAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnAfterFetch, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { cast } from '../../utils/cast-helpers';
import { DelayedExecutor } from '../../utils/workaround-utils';
import { Inject } from '@odinjs/odin';
import BaseController from '../BaseController';
import { Value } from '@philips-internal/oswald-ui-core';

interface NoticeTermDTO {
  content: string;
  title: string;
}

@Controller({ component: 'modal-account-creation-terms-of-use', fragment: 'account-creation-terms-modal' })
export default class AccountCreationTermsOfUseModalController extends BaseController {

  @Inject
    fetchTermsAPI!: FetchAPI;

  private delayedExecutor: DelayedExecutor<NoticeTermDTO> = new DelayedExecutor();

  @OnClose({ target: 'modal-account-creation-terms-of-use' })
  onCloseModalAccountCreationPrivacy(): void {
    this.historyService.back();
    //applicationContext.popNavigationItem()
  }

  @OnMount({ target: 'modal-account-creation-terms-of-use' })
  onMountModal(evt: MountEvent): void {
    const target: ModalAPI = cast(evt.target);
    const termType = this.context.get('termType') as Record<string, Value>;
    if(termType != null) {
      this.fetchTermsAPI.setParameters(termType);
      this.fetchTermsAPI.forceFetch();
    }
    this.delayedExecutor.onCompleted(e => {
      target.setTitle(e.title);
    })
  }

  @OnAfterFetch({ target: 'fetch-data' })
  onAfterFetchUpdateModalTitle(event: FetchEvent): void {
    this.delayedExecutor.completeNow(cast(event.data));
  }

}